import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

import { Text, type TextProps } from '@wartek-id/text'

import 'react-circular-progressbar/dist/styles.css'
import { hexToRgb } from 'utils/color'

export interface PropsCircularProgress {
  value?: number
  maxValue?: number
  percentage?: boolean
  textVariant?: TextProps['variant']
}

const colorProgress = hexToRgb('#0B5AE2')

const CircularProgress = ({
  value = 0,
  maxValue = 0,
  percentage = false,
  textVariant = 'heading-md',
}: PropsCircularProgress) => {
  const progressBarMinValue = -1
  const progressBarMaxValue = 100
  const progressBarCurrentValue = (progressBarMaxValue / maxValue) * value || 0

  const displayedCurrentValue = percentage ? (
    `${progressBarCurrentValue}%`
  ) : (
    <div className="flex flex-wrap justify-center">
      <span>{value}/</span>
      <span>{maxValue}</span>
    </div>
  )

  return (
    <CircularProgressbarWithChildren
      minValue={progressBarMinValue}
      maxValue={progressBarMaxValue}
      value={progressBarCurrentValue}
      styles={{
        path: {
          stroke: colorProgress,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          shapeRendering: 'geometricPrecision',
        },
      }}
    >
      <Text
        data-testid="circular-progress-text"
        variant={textVariant}
        color="primary"
        className="w-9/12 text-center break-words"
      >
        {displayedCurrentValue}
      </Text>
    </CircularProgressbarWithChildren>
  )
}

export default CircularProgress
